import { emailRegex, phoneRegex } from './regexPatterns';

export const isEmail = (value: string) => emailRegex.test(value);
export const isPhoneNumber = (value: string) => phoneRegex.test(value);

export function splitAddress(address: string) {
  if (!address) {
    return {
      streetNumber: '',
      streetName: '',
    };
  }

  const trimmedAddress = address.trim();
  const regex = /^(\d+[a-zA-Z]?\S*)\s+(.*)$/;
  const match = trimmedAddress.match(regex);

  if (match) {
    return {
      streetNumber: match[1],
      streetName: match[2],
    };
  }

  // In case the regex doesn't match, return default values
  return {
    streetNumber: '',
    streetName: trimmedAddress,
  };
}
